/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'goal-actions.archive-goal.generic-error-title': "Impossible d'archiver l'objectif",
  'goal-actions.copy-goal.cancel': 'Annuler',
  'goal-actions.copy-goal.close-modal': 'Fermer la fenêtre modale',
  'goal-actions.copy-goal.error': "Donnez un nom à votre objectif pour que tout le monde sache de quoi il s'agit",
  'goal-actions.copy-goal.failed-description':
    "Une erreur s'est produite lors du clonage de l'objectif. Veuillez réessayer ultérieurement.",
  'goal-actions.copy-goal.failed-description-forbidden': "Vous n'êtes pas autorisé à copier cet objectif.",
  'goal-actions.copy-goal.failed-title': 'Impossible de cloner cet objectif.',
  'goal-actions.copy-goal.followers': 'Abonnés',
  'goal-actions.copy-goal.goal-name': "Nom de l'objectif",
  'goal-actions.copy-goal.include': 'Inclure',
  'goal-actions.copy-goal.links': 'Liens',
  'goal-actions.copy-goal.submit': 'Envoyer',
  'goal-actions.copy-goal.success-description': "L'objectif a bien été cloné.",
  'goal-actions.copy-goal.success-link': "Afficher l'objectif cloné.",
  'goal-actions.copy-goal.success-title': 'Objectif {goalName} cloné.',
  'goal-actions.copy-goal.title': "Copier l'objectif",
  'goal-actions.follow-goal.follow-error-title': "Impossible de suivre l'objectif",
  'goal-actions.follow-goal.unfollow-error-title': "Impossible de ne plus suivre l'objectif",
  'goal-actions.goal-actions.archive-error-title': "impossible de restaurer l'objectif",
  'goal-actions.goal-actions.archive-goal': "Archiver l'objectif",
  'goal-actions.goal-actions.archive-restore-error-description':
    "les changements apportés à l'objectif n'ont pas pu être enregistrés. Veuillez réessayer ultérieurement.",
  'goal-actions.goal-actions.copy-goal': "Copier l'objectif",
  'goal-actions.goal-actions.follow': 'Suivre',
  'goal-actions.goal-actions.generic-error-description':
    "Une erreur s'est produite. Veuillez réessayer dans quelques minutes.",
  'goal-actions.goal-actions.restore-goal': "Restaurer l'objectif",
  'goal-actions.goal-actions.share': 'Partager',
  'goal-actions.goal-actions.show-more': 'Afficher plus',
  'goal-actions.goal-actions.unfollow': 'Ne plus suivre',
  'goal-actions.goal-content.follow-confirmation-description':
    'Nous vous enverrons une synthèse contenant les mises à jour de tous les objectifs que vous suivez au cours de la première semaine du mois prochain.',
  'goal-actions.restore-goal.generic-error-title': "Impossible de restaurer l'objectif",
};
